// ifMatrace
$(document).ready(function() {

  // addClassMatrace
  if (
    $('.breadcrumbs span').filter(function() {
      return $(this).text().trim() === 'Matrace'
    }).length > 0
  ) {
    $('body').addClass('matrace-detail')
  }

  // addClassNabytek
  if (
    $('.breadcrumbs span').filter(function() {
      return $(this).text().trim() === 'Nábytek do ložnice'
    }).length > 0
  ) {
    $('body').addClass('nabytek-do-loznice')
  }

  // addClassPolstare
  if (
    $('.breadcrumbs span').filter(function() {
      return $(this).text().trim() === 'Polštáře'
    }).length > 0
  ) {
    $('body').addClass('polstare-detail')
  }

  // addClassPrikryvky
  if (
    $('.breadcrumbs span').filter(function() {
      return $(this).text().trim() === 'Přikrývky'
    }).length > 0
  ) {
    $('body').addClass('prikryvky-detail')
  }

  // addClassLuzkoviny
  if (
    $('.breadcrumbs span').filter(function() {
      return $(this).text().trim() === 'Lůžkoviny'
    }).length > 0
  ) {
    $('body').addClass('luzkoviny-detail')
  }

  // addClassVybertePriplatek
  if ($('body').hasClass('matrace-detail')) {
    $('.detail-parameters tr.surcharge-list td select option')
      .filter(function() {
        return $(this).text().trim() === 'Vyberte příplatek'
      })
      .text('Zvolte jak velkou matraci odvezeme')
  }

  $(
    '<li class="col-xs-6 col-sm-6 col-lg-3 col-xl-3 specialOffer"><a href="/matrace-na-miru/"><img src="https://cdn.myshoptet.com/usr/www.vyspimese.cz/user/categories/thumb/matrace_na_m__ru.jpg" alt="Matrace na míru"></span><span class="text">Matrace na míru</span></a></li><li class="item--box col-xs-6 col-sm-4 col-lg-3 col-xl-3"><a href="https://www.vyspimese.cz/blog/jak-vybrat-matraci--inspirujte-se-v-nasem-radci/" target="_blank" alt="" /></a></span><span class="text">Jak vybrat matraci | Blog</span></li>'
  ).insertAfter('body.matrace .subcategories li:last-of-type')
})


// matraceTypeCategory
if ($('body').hasClass('type-category')) {
  if ($('.breadcrumbs span').length > 0 && $('main .subcategories').length > 0) {
    let containsMatrace = false

    $('.breadcrumbs span').each(function() {
      if ($(this).text().includes('Matrace')) {
        containsMatrace = true
        return false
      }
    })

    if (containsMatrace) {
      $('body').addClass('matrace')
    }
  }
}
